import React, { useEffect, useState } from "react";
import { Grid, Header, Divider, Button, Card } from "semantic-ui-react";
import {
  renderOptionField,
  renderTextField,
  renderCheckbox,
  renderTextAreaField,
} from "../formcomponents";
import { reduxForm, Field } from "redux-form";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { userData } from "../store/userData";
const CreateEmp = (props) => {
  const { handleSubmit, pristine, reset, submitting, change } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [allChecked, setAllChecked] = useState(false);

  const permissionFields = [
    "dashboard",
    "employee",
    "companyEmployee",
    "company",
    "contact",
    "invoice",
    "invoiceIndia",
    "receiveMoney",
    "spendMoney",
    "purchaseDetail",
    "dailyWork",
    "createCompany",
    "createVisa",
    "customerVisa",
    "fleetMgnt",
    "ticketImventory",
    "tourInvoice",
    "dataEntry",
    "dataEntryindia",
  ];
  useEffect(() => {
    if (id !== "null") {
      getUserDetail(id);
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);
  const getUserDetail = (id) => {
    console.log(id);
    axios
      .post(
        "https://ssbusinesssetup.com:8443/ssbusiness/visa/getBackOfficeUser",
        {
          email: id,
        }
      )
      .then((res) => {
        console.log("res data with pass", res.data);
        setInitialValues(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const setInitialValues = (data) => {
    console.log(data);
    props.initialize({
      ...data,
      // designation: data.designation,
      // email: data.email,
      // userPassword: data.userPassword,
      // userFirstName: data.userFirstName,
      // userId: data.userId,
      // userLastName: data.userLastName,
      // userRole: data.userRole,
      // dashboard: data.dashboard,
      // employee: data.employee,
      // company: data.company,
      // invoice: data.invoice,
      // receiveMoney: data.receiveMoney,
      // spendMoney: data.spendMoney,
      // purchaseDetail: data.purchaseDetail,
      // dailyWork: data.dailyWork,
      // createCompany: data.createCompany,
      // createVisa: data.createVisa,
      // ticketImventory: data.ticketImventory,
      // tourInvoice: data.tourInvoice,
      // dataEntry: data.dataEntry,
    });
  };
  const roles = [
    { text: "Admin", value: 1 },
    { text: "IT", value: 2 },
    { text: "Accounts", value: 3 },
    { text: "Sales", value: 4 },
    { text: "Marketting", value: 5 },
    { text: "Driver", value: 6 },
  ];

  const sumbitForm = (values) => {
    console.log(JSON.stringify(values, null, 2));
    axios
      .post(BaseUrl + "createBackOfficeUser", values)
      .then((res) => {
        if (res.data.errCode === 200) {
          Swal.fire("Success", "New Employee Added", "success");
          navigate("/list-employee");
        } else if (res.data.errCode === 202) {
          Swal.fire("Error", "This Emial Already Registered", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Add Employee
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="userFirstName"
                label="First Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="userLastName"
                label="Last Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="designation"
                label="Designation"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                name="email"
                label="Email"
                type="email"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="userPassword"
                label="Password"
                type="password"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="userRole"
                label="Role"
                options={roles}
                component={renderOptionField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Card>
        <Card.Content>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Card.Header content="Access Permission" />
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <input
                type="checkbox"
                checked={allChecked}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setAllChecked(checked);
                  permissionFields.forEach((field) => change(field, checked));
                }}
              />
              <span style={{ fontWeight: 600 }}>Select All</span>
            </div>
          </div>
          <br />
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="dashboard"
                  label="DASHBOARD"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="employee"
                  label="EMPLOYEE"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="companyEmployee"
                  label="COMPANY EMPLOYEE"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="company"
                  label="COMPANY"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="contact"
                  label="CONTACT"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="invoice"
                  label="INVOICE"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Field
                  name="invoiceIndia"
                  label="INVOICE India"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="receiveMoney"
                  label="RECEIVE MONEY"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="spendMoney"
                  label="SPEND MONEY"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="purchaseDetail"
                  label="PURCHASE DETAIL"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="dailyWork"
                  label="DAILY WORK"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="createCompany"
                  label="CREATE COMPANY"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="createVisa"
                  label="CREATE VISA"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="customerVisa"
                  label="CUSTOMER VISA"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="fleetMgnt"
                  label="FLEET MANAGMENT"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="ticketImventory"
                  label="Ticket Inventory"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="tourInvoice"
                  label="Tour Package Invoice"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="dataEntry"
                  label="Data Entry"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="dataEntryindia"
                  label="Data Entry India"
                  component={renderCheckbox}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
      <Divider hidden />{" "}
      <Button
        floated="right"
        positive
        disabled={buttonDisable}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>{" "}
      <br /> <br /> <br />
    </div>
  );
};

export default reduxForm({
  form: "CreateEmp",
})(CreateEmp);
